var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#FAFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 17.0625C36.25 17.3111 36.1512 17.5496 35.9754 17.7254C35.7996 17.9012 35.5611 18 35.3125 18H34.375V34.875C34.375 35.3723 34.1775 35.8492 33.8258 36.2008C33.4742 36.5525 32.9973 36.75 32.5 36.75H17.5C17.0027 36.75 16.5258 36.5525 16.1742 36.2008C15.8225 35.8492 15.625 35.3723 15.625 34.875V18H14.6875C14.4389 18 14.2004 17.9012 14.0246 17.7254C13.8488 17.5496 13.75 17.3111 13.75 17.0625C13.75 16.8139 13.8488 16.5754 14.0246 16.3996C14.2004 16.2238 14.4389 16.125 14.6875 16.125H35.3125C35.5611 16.125 35.7996 16.2238 35.9754 16.3996C36.1512 16.5754 36.25 16.8139 36.25 17.0625ZM20.3125 14.25H29.6875C29.9361 14.25 30.1746 14.1512 30.3504 13.9754C30.5262 13.7996 30.625 13.5611 30.625 13.3125C30.625 13.0639 30.5262 12.8254 30.3504 12.6496C30.1746 12.4738 29.9361 12.375 29.6875 12.375H20.3125C20.0639 12.375 19.8254 12.4738 19.6496 12.6496C19.4738 12.8254 19.375 13.0639 19.375 13.3125C19.375 13.5611 19.4738 13.7996 19.6496 13.9754C19.8254 14.1512 20.0639 14.25 20.3125 14.25Z",
    fill: "#E73C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon1);
export default __webpack_public_path__ + "static/media/DeleteModalIcon1.7f87132a5a77692f8794c0625cc674da.svg";
export { ForwardRef as ReactComponent };